<template>
    <section class="inAboutconBox">
        <div class="wrapper">
            <div class="inAboutCulture">
                <img v-if="cultureInfo.ico" :src="$root.$TEMP_URL+cultureInfo.ico" />
            </div>
        </div>
    </section>
</template>

<script>
import {getContent} from '../../../api'
export default {
    data() {
        return {
            cultureInfo:{}
            
        };
    },
    async created(){
      const isZhong = this.$parent.isZhong;
      let resCulture;
      
      if(isZhong){
          resCulture = await getContent(238);
      }else{
          resCulture = await getContent(207);
      }

      //获取企业文化
      this.cultureInfo = resCulture.data;
    },
   
};
</script>

<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';
.inAboutconBox {
   background: #fafdfd;  
   padding: 82px 0;
  .wrapper {
    .inAboutCulture {
      width: 1200px;  
      margin: 0 98px 78px 0;
      position: relative;
      z-index: 2;
      img {
        width: 100%;
      }
      &::before{
        content: "";
        width: 200px;
        height: 400px;
        background: $themeColor;
        position: absolute;
        right: -98px;
        bottom: -78px;
        z-index: -1;
    }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/About/Culture/Culture.vue